import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

Vue.use(Vuex);

const state = {
    mounted:false,
    user: {},
    calendarQuery:0,
    activeDays: [],
    selectedDayHours: [],
    selectedHour: '',
    selectedDay: {},
    selectedInterval:{start:undefined, end:undefined, source:undefined},
    sidebarVisible: true,
    status: {
        noise:false,
        weather:false
    },
    systemStatus:{},
    settings:{},
    localSettings:{},
    unsavedLocalSettings: {},
    realtimeEnabled: false,
    firmware: {},
    screenSize:2,
    isDownloading: {
        enabled: false,
        progress: 0
    }
}

const store = new Vuex.Store({
    state,
    actions,
    getters,
    mutations
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js